import ActivityIndicator from 'common/views/activityIndicator';
import Title from 'common/views/title';
import DefaultMargin from 'components/DefaultMargin';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { StoreContext } from 'stores';
import CatalogArchiveTable from './views/catalogArchiveTable';

const ArchiveView: React.FunctionComponent = observer(() => {
  const { archiveStore } = React.useContext(StoreContext);
  let items = archiveStore.get_archive();

  if (items === undefined) {
    return <ActivityIndicator />;
  }

  return (
    <DefaultMargin>
      <Title>Katalog Arkiv</Title>
      <CatalogArchiveTable items={items} />
    </DefaultMargin>
  );
});

export default ArchiveView;
